import { Container, Group, Text, ThemeIcon, Title } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { LuArrowLeft, LuUsers } from 'react-icons/lu'
import { CustomerForm } from '@/frontend/components/marina/CustomerForm'
import { useCreateCustomer } from '@/frontend/hooks/useCustomers'

export const Route = createFileRoute('/dashboard/accounts/customers/new')({
  component: NewCustomer,
})

function NewCustomer() {
  const navigate = useNavigate()
  const mutation = useCreateCustomer()

  return (
    <Container size="lg" py="md">
      <Group gap="sm" align="center" mb="lg">
        <Link to="/dashboard/accounts/customers" style={{ color: 'var(--mantine-color-dimmed)', display: 'flex' }}>
          <LuArrowLeft size={18} />
        </Link>
        <ThemeIcon variant="light" color="laut" size="lg" radius="md">
          <LuUsers size={18} />
        </ThemeIcon>
        <div>
          <Title order={2} ff="var(--font-display)" fw={600}>
            Tambah Pelanggan Baru
          </Title>
          <Text size="xs" c="dimmed">
            Isi informasi pelanggan — bagian kontak & dokumen bisa dilengkapi nanti
          </Text>
        </div>
      </Group>

      <CustomerForm
        submitLabel="Simpan Pelanggan"
        submitting={mutation.isPending}
        onCancel={() => navigate({ to: '/dashboard/accounts/customers' })}
        onSubmit={async (values) => {
          try {
            const { customer } = await mutation.mutateAsync(values)
            notifications.show({
              title: 'Pelanggan berhasil ditambahkan',
              message: `${customer.firstName} ${customer.lastName} telah terdaftar.`,
              color: 'teal',
            })
            navigate({ to: `/dashboard/accounts/customers/${customer.id}` as any })
          } catch (e: unknown) {
            notifications.show({
              title: 'Gagal menyimpan',
              message: e instanceof Error ? e.message : 'Silakan coba lagi',
              color: 'red',
            })
          }
        }}
      />
    </Container>
  )
}
